import { generateConfigPayload } from 'pages/reference-implementation/provisioning/RI003AWS/utils';
import { platformManaged, selectedEnv as selectedEnvConst } from './constant';
import { isSecondaryGrpOwner } from './checkValidFields';

export const getPreviewPayload = ({ order, secondaryApproverValue }) => {
    const components = order?.resourceMgmt?.[selectedEnvConst]?.components;
    const awsAccComponent = components?.find((c) => c?.configurationComponentCode === 'AWSACC');
    const businessApplication = awsAccComponent?.configureData?.businessApplication || null;
    return {
        ...(order?.orderId && {
            'order-id': order?.orderId,
        }),
        'is-external': order?.isExternal === 'Yes',
        'application-service': order?.appProfile,
        ...(order?.businessApp && { 'business-application': order?.businessApp }),
        ...(businessApplication && { 'business-application': businessApplication }),
        'application-name': order?.applicationName,
        'app-short-name': order?.appShortName,
        'manager-id': order?.appOwnerDetails?.gpid,
        'business-owner-id': order?.businessContactDetails?.gpid,
        sector: order?.sector,
        department: order?.department,
        'application-region': order?.appRegion,
        ...(order?.landingZoneDetails?.region && { region: order?.landingZoneDetails?.region }),
        'budget-code': order?.budgetCode,
        'data-classification': order?.dataClassification,
        ...(order?.program && { program: order?.program }),
        ...(order?.isExternal === 'Yes' && {
            'app-support-mail-id': order?.appSupportMailId,
        }),
        ...(order?.myCertADGroup === 'Yes' && {
            'active-directory-certificate-group': order?.adCertGroup,
        }),
        ...(order?.myCertADGroup === 'No' && {
            'active-directory-group-owner-id': order?.myCertADGroupOwnerDetails?.gpid,
        }),
        ...(isSecondaryGrpOwner({ order }) &&
            secondaryApproverValue?.value?.groupOwnerDetails?.gpid && {
                'active-directory-group-owner-id': secondaryApproverValue?.value?.groupOwnerDetails?.gpid,
            }),
        'environment-configurations': [
            {
                environment: order?.environment,
                ...(order?.isExternal === 'Yes' && { 'application-url': order?.appUrl }),
                ...(order?.privilegedADGroup === 'Yes' && { 'contributor-ad-groups': order?.privilegedADGroupList?.map((z) => z?.contributorValue) }),
                ...(order?.environment?.toLowerCase() !== 'production' &&
                    order?.nonPrivilegedADGroup === 'Yes' && { 'reader-ad-groups': order?.nonPrivilegedADGroupList?.map((z) => z?.readerValue) }),
                components: generateConfigPayload(components),
            },
        ],
    };
};

export const getCostCalcPayload = ({ order, selectedEnv }) => {
    const components = order?.resourceMgmt?.[selectedEnv]?.components;
    return {
        isExternal: order?.isExternal === 'Yes',
        catalogServiceCode: order?.catalogCode,
        components: generateConfigPayload(components),
        environment: order?.environment,
        sector: order?.sector,
        applicationRegion: order?.appRegion,
        region: order?.landingZoneDetails?.region,
        platformManaged,
    };
};

export const getOrderPayload = ({ order, secondaryApproverValue }) => {
    const components = order?.resourceMgmt?.[selectedEnvConst]?.components;
    const awsAccComponent = components?.find((c) => c?.configurationComponentCode === 'AWSACC');
    const businessApplication = awsAccComponent?.configureData?.businessApplication || null;

    return {
        ...(order?.orderId && {
            'order-id': order?.orderId,
        }),
        'is-external': order?.isExternal === 'Yes',
        'application-service': order?.appProfile,
        ...(order?.businessApp && { 'business-application': order?.businessApp }),
        ...(businessApplication && { 'business-application': businessApplication }),
        'application-name': order?.applicationName,
        'app-short-name': order?.appShortName,
        'manager-id': order?.appOwnerDetails?.gpid,
        'business-owner-id': order?.businessContactDetails?.gpid,
        sector: order?.sector,
        department: order?.department,
        // ...(['cgf']?.includes(order?.sector?.toLowerCase()) && { division: order?.division }),
        'application-region': order?.appRegion,
        ...(order?.landingZoneDetails?.region && { region: order?.landingZoneDetails?.region }),
        'budget-code': order?.budgetCode,
        ...(order?.enabledManualBudgetCode && { enabledManualBudgetCode: order?.enabledManualBudgetCode }),
        'data-classification': order?.dataClassification,
        ...(order?.program && { program: order?.program }),
        ...(order?.isExternal === 'Yes' && {
            'app-support-mail-id': order?.appSupportMailId,
        }),
        ...(order?.myCertADGroup === 'Yes' && {
            'active-directory-certificate-group': order?.adCertGroup,
        }),
        ...(order?.myCertADGroup === 'No' && {
            'active-directory-group-owner-id': order?.myCertADGroupOwnerDetails?.gpid,
        }),
        ...(isSecondaryGrpOwner({ order }) &&
            secondaryApproverValue?.value?.groupOwnerDetails?.gpid && {
                'active-directory-group-owner-id': secondaryApproverValue?.value?.groupOwnerDetails?.gpid,
            }),
        'environment-configurations': [
            {
                environment: order?.environment,
                ...(order?.isExternal === 'Yes' && { 'application-url': order?.appUrl }),
                ...(order?.privilegedADGroup === 'Yes' && { 'contributor-ad-groups': order?.privilegedADGroupList?.map((z) => z?.contributorValue) }),
                ...(order?.environment?.toLowerCase() !== 'production' &&
                    order?.nonPrivilegedADGroup === 'Yes' && { 'reader-ad-groups': order?.nonPrivilegedADGroupList?.map((z) => z?.readerValue) }),
                components: generateConfigPayload(components),
            },
        ],
    };
};

export const getResubmitOrderPayload = ({ order }) => {
    const catalog = order?.catalogServices?.[0]?.catalogConfig;

    const environmentDetails = catalog?.environmentConfigurations[0];
    const components = environmentDetails?.components;

    return {
        ...(catalog?.projectId && { 'project-id': catalog?.projectId }),
        ...(catalog?.businessUnit && { 'business-unit': catalog?.businessUnit }),
        sector: catalog?.sector,
        'application-region': catalog?.region,
        'budget-code': catalog?.costCenter,
        ...(catalog?.billingInformation && { 'billing-information': catalog?.billingInformation }),
        ...(catalog?.businessApplication && { 'business-application': catalog?.businessApplication }),
        'data-classification': catalog?.dataClassification,
        'manager-id': order?.manager?.id,
        'application-service': catalog?.applicationService,
        'application-name': catalog?.applicationName,
        'app-short-name': catalog?.applicationShortName,
        'business-owner-id': catalog?.businessOwnerId,
        ...(catalog?.readerAdGroup && catalog?.readerAdGroup?.length && { 'reader-ad-group': catalog?.readerAdGroup }),
        ...(catalog?.contributorAdGroup && catalog?.contributorAdGroup?.length && { 'contributor-ad-group': catalog?.contributorAdGroup }),

        ...(catalog?.isExternal === 'Yes' && {
            'app-support-mail-id': catalog?.appSupportMailId,
        }),
        'active-directory-certificate-group': order?.adCertGroup,

        'active-directory-group-owner-id': order?.myCertADGroupOwnerDetails?.gpid,

        ...(order?.activeDirectoryGroupOwner && { 'active-directory-group-owner-id': order?.activeDirectoryGroupOwner?.id }),
        'environment-configurations': [
            {
                environment: environmentDetails?.environmentDisplayName,
                ...(environmentDetails?.applicationUrl && { 'application-url': environmentDetails?.applicationUrl }),
                ...(environmentDetails?.contributorAdGroups &&
                    environmentDetails?.contributorAdGroups?.length && {
                        'contributor-ad-groups': environmentDetails?.contributorAdGroups?.map((z) => z),
                    }),
                ...(environmentDetails?.environmentDisplayName?.toLowerCase() !== 'production' &&
                    environmentDetails?.readerAdGroups &&
                    environmentDetails?.readerAdGroups?.length && { 'reader-ad-groups': environmentDetails?.readerAdGroups?.map((z) => z) }),
                components: components.map((component) => ({
                    ...component,
                    program: component.program === 'Global Shared' ? 'Not Applicable' : component.program,
                })),
            },
        ],
    };
};

export const getdevXOrderPayload = ({ order, params, riOrderId }) => {
    const components = order?.resourceMgmt?.[selectedEnvConst]?.components;

    return {
        journeyId: params?.journeyId,
        applicationId: params?.appRegistrationId,
        workflowName: 'InfraOnboarding',
        atomicWorkflowRequestList: [
            {
                atomicWorkflowName: 'InfraOnboarding_RI003aws',
                inputData: {
                    orderId: riOrderId,
                    sector: order?.sector,
                    applicationService: order?.appProfile,
                    applicationName: order?.applicationName,
                    applicationShortName: order?.appShortName,
                    applicationRegion: order?.appRegion,
                    applicationOwner: order?.appOwnerDetails,
                    businessOwner: order?.businessContactDetails,
                    budgetCode: order?.budgetCode,
                    dataClassification: order?.dataClassification,
                    riDevelopmentType: order?.isExternal === 'Yes' ? 'Web Application' : 'Microservice',
                    ...(order?.isExternal === 'Yes' && {
                        teamDL: order?.appSupportMailId,
                        activeDirectoryCertificateGroup: order?.adCertGroup,
                    }),
                    ...(order?.myCertADGroup === 'Yes' && {
                        activeDirectoryCertificateGroup: order?.adCertGroup,
                    }),
                    ...(order?.myCertADGroup === 'No' && {
                        activeDirectoryGroupOwner: order?.myCertADGroupOwnerDetails?.gpid,
                    }),
                    'environment-configurations': [
                        {
                            environment: order?.environment,
                            ...(order?.isExternal === 'Yes' && { 'application-url': order?.appUrl }),
                            'contributor-ad-groups': order?.privilegedADGroupList?.map((z) => z?.contributorValue),
                            'reader-ad-groups': order?.nonPrivilegedADGroupList?.map((z) => z?.readerValue),
                            components: generateConfigPayload(components),
                        },
                    ],
                },
            },
        ],
    };
};
